import { defineSlotRecipe } from '@chakra-ui/react';

export const accommodationTileSlotRecipe = defineSlotRecipe({
    slots: [
        'amenities',
        'container',
        'details',
        'flexDates',
        'images',
        'info',
        'price',
        'priceConfirmation',
        'promoText',
        'rating',
    ],
    base: {
        container: {
            boxShadow: 'tile',
            borderRadius: 'tile',
            columnGap: 2,
            rowGap: 3,
            gridTemplateColumns: 'auto 1fr',
            pr: 2,
            mb: 4,
            md: {
                gridTemplateColumns: 'auto 1fr auto',
                rowGap: 3,
                columnGap: 4,
                pr: 4,
                pl: 4,
                py: 4,
                mb: 6,
            },
            _hover: {
                '& .accommodation-tile-cta': {
                    color: 'colorPalette.contrast',
                    bg: 'colorPalette.solid/90',
                },
            },
        },
        images: {
            w: '133px',
            gridColumn: 1,
            gridRow: '1 / 6',
            h: 'full',
            md: {
                gridRow: '1 / 5',
                w: '280px',
            },
            '& img': {
                bgColor: 'gray.200',
                borderRadius: {
                    md: 'tileImage',
                },
                borderLeftRadius: {
                    base: 'tile',
                    md: undefined,
                },
                base: {
                    position: 'absolute', // pos absolute to prevent grid resizing
                    left: 0,
                    top: 0,
                    h: 'full',
                },
                md: {
                    h: 'auto',
                    position: 'relative',
                },
            },
        },
        info: {
            gridColumn: 2,
            gridRow: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            md: {
                gridRow: '1 / span 2',
                pt: 0,
            },
            pt: 2,
        },
        rating: {
            gridColumn: 2,
            gridRow: 2,
            md: {
                gridRow: 1,
                gridColumn: 3,
            },
        },
        amenities: {
            gridRow: 3,
            gridColumn: 2,
            md: {
                gridRow: 3,
            },
        },
        details: {
            gridColumn: 2,
            gridRow: 4,
            alignSelf: 'end',
        },
        flexDates: {},
        price: {
            gridColumn: 2,
            gridRow: 5,
            alignItems: 'flex-end',
            gap: 1,
            md: {
                alignSelf: 'end',
                gridRow: '2 / span 3',
                gridColumn: 3,
            },
        },
        priceConfirmation: {
            fontSize: {
                base: '13px',
                md: 'xs',
            },
            color: 'gray.500',
            textAlign: {
                base: 'left',
                md: 'right',
            },
        },
        promoText: {
            fontSize: 'xs',
            color: 'gray.500',
            _before: {
                content: 'open-quote',
            },
            _after: {
                content: 'close-quote',
            },
        },
    },
    variants: {
        variant: {},
    },
});
